import { render, staticRenderFns } from "./TwProcessGroupListEditDeliveryTableModal.vue?vue&type=template&id=12423a41&"
import script from "./TwProcessGroupListEditDeliveryTableModal.vue?vue&type=script&lang=js&"
export * from "./TwProcessGroupListEditDeliveryTableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports